// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import ChartsController from './charts_controller'
import DragDropController from './drag_drop_controller'
import ReportsController from './reports_controller'
import ShelterSetupController from './shelter_setup_controller'
import SupersetDashboardController from './superset_dashboard_controller'
import TabsController from './tabs_controller'
import UptimeChartController from './uptime_chart_controller'
import UptimeSelectController from './uptime_select_controller'
import VconnAssemblySetupController from './vconn_assembly_setup_controller'
import ReplacementController from './replacement_controller'
import QrScannerController from './qr_scanner_controller'
import FlashController from './flash_controller'
import DriveIntegrationController from './drive_integration_controller'
import WorkordersController from './workorders_controller'
import CarouselController from './carousel_controller'
import FieldQaController from './field_qa_controller'
import ShelterTestSuiteController from './shelter_test_suite_controller'
import RedirectQrSupportController from './redirect_qr_support_controller'
import { ToggleController, TextSearchController, SearchFormController } from './toggle_controller'
import ToplightControlsController from './toplight_controls_controller'
import DropdownController from './dropdown_controller'
import PduControlsController from './pdu_controls_controller'
import WorkorderCommentsController from './workorder_comments_controller'
import HeartbeatsController from './heartbeats_controller'
import WorkorderUploadsController from './workorder_uploads_controller'
import WorkordersCarouselController from './workorders_carousel_controller'
import PairShelterController from './pair_shelter_controller'
import CustomDatepickerController from './custom_datepicker_controller'
import LocationRefreshController from './location_refresh_controller'
import DiagnosticReportController from './diagnostic_report_controller'
import EventTabsController from './event_tabs_controller'
import ParkingSessionFiltersController from './parking_session_filters_controller'
import PaginationController from './pagination_controller'
import ToplightHistoryDatepickerController from './toplight_history_datepicker_controller'
import KitDiagnosticController from './kit_diagnostic_controller'
import ShelterDiagnosticsController from './shelter_diagnostics_controller'
import ReportStatusPollController from './report_status_poll_controller'
import ShelterIntegrationController from './shelter_integration_controller'
import ShelterSelectorController from './shelter_selector_controller'
import LadotImhPageController from './ladot_imh_page_controller'
import SimActivationController from './sim_activation_controller'
import GdsVolumeController from './gds_volume_controller'

application.register('charts', ChartsController)
application.register('drag-drop', DragDropController)
application.register('reports', ReportsController)
application.register('shelter-setup', ShelterSetupController)
application.register('superset-dashboard', SupersetDashboardController)
application.register('tabs', TabsController)
application.register('uptime-chart', UptimeChartController)
application.register('uptime-select', UptimeSelectController)
application.register('vconn-assembly-setup', VconnAssemblySetupController)
application.register('replacement', ReplacementController)
application.register('qr-scanner', QrScannerController)
application.register('flash', FlashController)
application.register('drive-integration', DriveIntegrationController)
application.register('workorders', WorkordersController)
application.register('carousel', CarouselController)
application.register('field-qa', FieldQaController)
application.register('shelter-test-suite', ShelterTestSuiteController)
application.register('redirect-qr-support', RedirectQrSupportController)
application.register('toggle', ToggleController)
application.register('text-search', TextSearchController)
application.register('search-form', SearchFormController)
application.register('toplight-controls', ToplightControlsController)
application.register('dropdown', DropdownController)
application.register('pdu-controls', PduControlsController)
application.register('workorder-comments', WorkorderCommentsController)
application.register('heartbeats', HeartbeatsController)
application.register('workorder-uploads', WorkorderUploadsController)
application.register('workorder-carousel', WorkordersCarouselController)
application.register('pair-shelter', PairShelterController)
application.register('custom-datepicker', CustomDatepickerController)
application.register('location-refresh', LocationRefreshController)
application.register('diagnostic-report', DiagnosticReportController)
application.register('event-tabs', EventTabsController)
application.register('parking-session-filters', ParkingSessionFiltersController)
application.register('pagination', PaginationController)
application.register('toplight-history-datepicker', ToplightHistoryDatepickerController)
application.register('shelter-selector', ShelterSelectorController)
application.register('kit-diagnostic', KitDiagnosticController)
application.register('shelter-diagnostics', ShelterDiagnosticsController)
application.register('report-status-poll', ReportStatusPollController)
application.register('shelter-integration', ShelterIntegrationController)
application.register('ladot-imh-page', LadotImhPageController)
application.register('sim-activation', SimActivationController)
application.register('gds-volume', GdsVolumeController)
